import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { updateLocationSearch } from '../../../utils/url';

import styles from './Categories.module.css';

const categoryClasses = (selectedCategoryId, categoryId, isChild) => {
  const active = selectedCategoryId === (categoryId && categoryId.toString());
  return classNames('cur-pointer', styles.category, 'fw-light', {
    [styles.active]: active,
    [styles.childCategory]: isChild,
  });
};

function Categories({
  categories,
  selectedCategoryId,
  handleCategoryTracking,
  isChild,
}) {
  return (
    <div className={styles.categoryContainer}>
      {categories.map((category) => (
        <div
          className={categoryClasses(selectedCategoryId, category.id, isChild)}
          key={category.id}
        >
          <Link
            className={classNames(
              'category-button',
              'naked-button',
              'c-black',
              'cur-pointer',
              'fs-14',
              'pad-8'
            )}
            to={updateLocationSearch({
              category: category.id,
              product_link: null,
            })}
            onClick={() => handleCategoryTracking(category.name)}
            data-dd-action-name={`${category.name} category button`}
          >
            {category.name}
            {category.children.length > 0 && (
              <i className={classNames(styles.icon, 'far fa-angle-down')} />
            )}
          </Link>

          {category.children.length > 0 && (
            <Categories
              categories={category.children}
              selectedCategoryId={selectedCategoryId}
              isChild
              handleCategoryTracking={handleCategoryTracking}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default Categories;
